import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormCompanyService } from 'src/app/layouts/main-v2/services/forms/form-company.service';
import { PostalCodeService } from 'src/app/services/postal-code.service';

@Component({
  selector: 'app-company-address-v2',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.sass']
})
export class AddressComponent implements OnInit {
  formCompanyAddress!: FormGroup;
  isLoadingCep = false;

  constructor(
    private readonly fb: FormBuilder,
    private readonly companyFormService: FormCompanyService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly postalCodeService: PostalCodeService
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }

  private buildForm(): void {
    const savedAddress = this.companyFormService.getAddress();

    this.formCompanyAddress = this.fb.group({
      cep: [savedAddress?.cep ?? '', Validators.required],
      street: [savedAddress?.street ?? '', Validators.required],
      number: [savedAddress?.number ?? '', Validators.required],
      complement: [savedAddress?.complement ?? ''],
      neighborhood: [savedAddress?.neighborhood ?? '', Validators.required],
      city: [savedAddress?.city ?? '', Validators.required],
      state: [savedAddress?.state ?? '', Validators.required]
    });
  }

  async onCepInput(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '');

    // Aplica máscara de CEP: 00000-000
    if (value.length > 5) {
      value = value.substring(0, 5) + '-' + value.substring(5, 8);
    }
    input.value = value;
    this.formCompanyAddress.get('cep')?.setValue(value, { emitEvent: false });

    // Busca endereço quando CEP tiver 8 dígitos
    const digits = value.replace(/\D/g, '');
    if (digits.length === 8) {
      await this.searchCep(digits);
    }
  }

  private async searchCep(cep: string): Promise<void> {
    this.isLoadingCep = true;
    try {
      const address = await this.postalCodeService.fetchAddressForBrazilianCEP(cep);
      if (address && !address.erro) {
        this.formCompanyAddress.patchValue({
          street: address.logradouro,
          neighborhood: address.bairro,
          city: address.localidade,
          state: address.uf
        });
      }
    } catch (error) {
      console.error('Erro ao buscar CEP:', error);
    } finally {
      this.isLoadingCep = false;
    }
  }

  goBack(): void {
    this.router.navigate(['../info'], { relativeTo: this.route });
  }

  saveAndNext(): void {
    if (this.formCompanyAddress.invalid) {
      this.formCompanyAddress.markAllAsTouched();
      return;
    }

    this.companyFormService.setAddress(this.formCompanyAddress.value);
    this.router.navigate(['../contact'], { relativeTo: this.route });
  }
}
